module.exports = __webpack_public_path__ + "static/media/ConCOVElogo.1a3ca107.png";